export default __webpack_public_path__ + "static/media/art-infiltrate.1fa764fb.jpg";